import { Component, EventEmitter, forwardRef, HostListener, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzFilterOptionType, NzOptionComponent, NzSelectComponent, NzSelectItemInterface } from 'ng-zorro-antd/select';
import { OptionModel } from '../../../vss-ui.model';
import { AbstractControlComponent } from '../../../classes/abstract-control.component';
import {Ultilities} from '../../../extensions/ultilities';
// import { Ultilities } from '../../extentions/ultilities';
// import { OptionModel } from '../../interface/option-model';
// import { AbstractControlComponent } from '../../class/abstract-control.component';

@Component({
  selector: 'cs-select',
  templateUrl: './cs-select.component.html',
  styleUrls: ['./cs-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CsSelectComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CsSelectComponent extends AbstractControlComponent<any | any[]> implements OnInit {

  @Input() cssWidth!: string; //truyền giá trị width cho nz-select
  @Input() csAllowClear: boolean = true;
  @Input() csShowSearch: boolean = true;
  @Input() css: boolean = false;
  @Input() csMaxTagCount!: number;
  @Input() csOption: OptionModel[] = [];
  @Input() csMode: 'multiple' | 'tags' | 'default' = 'default';
  @Input() isGroup = false;
  @Input() isObjectValue = false;
  @Input() csSize : 'large' | 'small' | 'default' = 'default';
  @Input() isLoading = false;
  @ViewChild('select') select!: NzSelectComponent;
  @Output() csOpenChange = new EventEmitter();

  filterOptionFn: NzFilterOptionType = (input?: string, option?: NzSelectItemInterface): boolean => ((Ultilities.removeVietnameseAccents(option?.nzLabel?.toString() || '')).includes(Ultilities.removeVietnameseAccents(input || '')))

  constructor() {
    super();
  }

  ngOnInit() {
  }

  onModelChange(obj: any){
    if(this.isObjectValue && typeof(obj)==='object' && obj){
      this.onChangeFn(obj?.value);
    }else{
      this.onChangeFn(obj);
    }
    this.csChange.emit(obj);
  }

  onOpenChange(value: any) {
    this.csOpenChange.emit(value)
  }

}
